/**
 * @deprecated Import from 'src/integrations/react/index.js' instead.
 */
export { run as runReactInstallerAgent, config as REACT_AGENT_CONFIG } from '../integrations/react/index.js';
